/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "bootstrap/dist/css/bootstrap.min.css"
import './src/styles/global.css';

import Session from './src/lib/session';

window.session = new Session();

// function addScriptTag(code, isJquery) {
//     return new Promise(function (resolve, reject) {
//       var script = document.createElement('script');
//       script.onload = resolve;
//       script.onerror = reject;
//       isJquery ? (script.text = code) : (script.src = code);
//       document.body.appendChild(script)
//     })
//   }
  

// export const onClientEntry = () => {
//     window.onload = () => {
//         addScriptTag('https://tool.votinginfoproject.org/app.js').then(function() {
//             return addScriptTag('https://sos.oregon.gov/js/jquery-1.8.2.min.js');
//           }).then(function() {
//             return addScriptTag(`vit.load({
//                 modal: true,
//                 title: 'Dropbox Locator',
//                 width: '100%', 
//                 height: '550px',
//                 logo: 'https://theoregonvoterguide.com/icons/icon-144x144.png',
//                 colors: {
//                   'header': '#dc851f',
//                   'landscapeBackgroundHeader': '#dc851f'
//                 },
//                 language: 'en',
//                 json: {
//                   text: {
//                     headers: {
//                       pollingLocation: 'Drop-off Locations'
//                     }
//                   }
//                 }
            
//             }, function(){
//                     setTimeout(function(){ $("#_vit").css({"width": "100%", "height" : "550px"  });}, 500);
                    
//             }());`, true);
//           });
//     }
// }

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  if (!prevRouterProps) return true;

  // Strip language prefixes (e.g., /es/about -> /about, /es -> /)
  const stripLang = (pathname) => pathname.replace(/^\/es(\/|$)/, "/") || "/";

  const prevPath = stripLang(prevRouterProps.location.pathname);
  const nextPath = stripLang(routerProps.location.pathname);

  // If staying on the same logical page, retain the current scroll position:
  if (prevPath === nextPath) {
    return false;
  }

  // Otherwise, default to standard scroll-to-top behavior for new pages
  return true;
};

// export const onRouteUpdate = ({ location }) => {
//   if (typeof window === "undefined" || !location?.hash) return;

//   const id = decodeURIComponent(location.hash.replace(/^#/, ""));
//   let userHasScrolled = false;

//   const onUserInteraction = () => {
//     userHasScrolled = true;
//     window.removeEventListener("wheel", onUserInteraction);
//     window.removeEventListener("touchstart", onUserInteraction);
//   };

//   window.addEventListener("wheel", onUserInteraction, { passive: true });
//   window.addEventListener("touchstart", onUserInteraction, { passive: true });

//   const scrollToTarget = () => {
//     if (userHasScrolled) return;
//     const el = document.getElementById(id);
//     if (el) {
//       const rect = el.getBoundingClientRect();
//       // Re-scroll if the element drifted away from the top offset (due to image layout shifts)
//       if (Math.abs(rect.top - 80) > 40) {
//         el.scrollIntoView({ behavior: "smooth" });
//       }
//     }
//   };

//   // Check on window load and staggered intervals as images load on fresh visit
//   window.addEventListener("load", scrollToTarget, { once: true });
//   [150, 400, 800, 1400].forEach((delay) => {
//     setTimeout(scrollToTarget, delay);
//   });
// };